/* eslint-disable */
import styles from './index.module.scss'
import { Button } from '../../button'
import { Link } from 'react-router-dom'

const MagazineCard = ({ to, img, title, label }) => {
  return (
    <div className={styles.container}>
      <Link to={to} className={styles.card}>
        <Button to={'#'}>DOWNLOAD</Button>
        <figure>
          <img src={img} alt={title} />
          <div className={styles.label}>
            {label && (
              <span
                style={
                  label === 'New'
                    ? { backgroundColor: '#FF3D71' }
                    : { backgroundColor: '#4500D9' }
                }
              >
                {label}
              </span>
            )}
          </div>
        </figure>
      </Link>
      <p className={styles.title}>{title}</p>
    </div>
  )
}

export default MagazineCard
